import React, { useCallback, useEffect } from 'react';
import { createPortal } from 'react-dom';
import styles from './Modal.module.css';
import { ModalProps } from './Modal.props';

const PORTAL_ID = 'modal';

function Modal({
  children,
  onClose,
  allowCloseOnClickOutside = true,
  useCloseBtn = true,
  className,
}: ModalProps) {
  // Общая ф-ция закрытия
  const closeFn = useCallback(
    (e?: React.MouseEvent<HTMLElement>) => {
      if (e?.target !== e?.currentTarget) return;
      if (onClose) onClose();
    },
    [onClose],
  );

  // Закрываем на Esc
  const keyboardHandler = useCallback(
    (e?: KeyboardEvent) => {
      e?.code === 'Escape' && closeFn();
    },
    [closeFn],
  );

  // Обработка нажатий клавиш при открытой модалке
  useEffect(() => {
    document.addEventListener('keydown', keyboardHandler);
    return () => document.removeEventListener('keydown', keyboardHandler);
  }, [keyboardHandler]);

  useEffect(() => {
    document.documentElement.style.overflow = 'hidden';

    return () => {
      document.documentElement.style.overflow = 'visible';
    };
  }, []);

  const modalContent = (
    <div className={`${styles.container} ${className || ''}`}>
      <div className={styles.modal_area}>
        <div
          className={styles.window}
          onClick={allowCloseOnClickOutside ? closeFn : () => void 0}
        >
          {children}
        </div>
        {useCloseBtn && (
          <span
            className={styles.icon_close}
            onClick={onClose}
            data-qa-marker="close_modal"
          />
        )}
      </div>
    </div>
  );

  return createPortal(modalContent, document.getElementById(PORTAL_ID) as HTMLElement);
}

export default Modal;
